function timespan() {
  'ngInject';
  return function(number) {

    var years = Math.floor(number / (86400 * 365));
    var days = Math.floor(number / 86400) % 365;
    var hours = Math.floor(number / 3600) % 24;
    var minutes = Math.floor(number / 60) % 60;
    var seconds = Math.floor(number % 60);
    var str = '';

    if (years > 0) {
      str += String(years) + 'y ';
    }

    if (days > 0 && years < 10) {
      str += String(days) + 'd ';
    }

    if (hours > 0 && years < 1 && days < 10) {
      str += String(hours) + 'H ';
    }

    if (minutes > 0 && years < 1 && days < 1) {
      str += String(minutes) + 'm ';
    }

    if (seconds > 0 && years < 1 && days < 1 && hours < 1) {
      str += String(seconds) + 's ';
    }

    if (!str) {
      str = 'n/a';
    }

    return str;

  };
}
export { timespan };
